import axios from 'axios'

/**
 * helper function which returns boolean indicating if any of the provided errors is a 403 forbidden error
 * it is used to determine if the user has permissions to access the page or not
 * it accepts a variable number of errors as arguments and checks if any of them is a 403 error
 * it returns true if at least one of the errors is a 403 error, otherwise it returns false
 */
export const isForbidden = (...errors: unknown[]): boolean =>
  errors.some((err) => axios.isAxiosError(err) && err.response?.status === 403)
